<template>
  <div class="modalAdd">
    <b-modal id="modalVideoMerge" ref="modalVideoMerge" centered size="lg" modal-class="modal-no-border modal-radius top-mb" @show="onOpen" no-close-on-backdrop>
      <template v-slot:modal-header="{close}">
        <div class="title-modal text-center w-100 ">
          <h2 class="title">動画を統合する</h2>
          <div class="btn-closeModal" @click="closeModalAdd">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
        </div>
      </template>
      <div class="modalUser--main px-3" :class="{'chrome': checkChrome, 'firefox': checkFirefox }">
        <form autocomplete="off">
          <div class="form-group">
            <label for="name" class="vendor__label mt-15">ファイル名<span class="required">*</span></label>
            <div class="input-group">
              <input type="text" name="name" id="name" class="input-form" placeholder="ファイル名を入力してください" v-model="fileName" >
              <small v-if="fileError" class="text-input error">{{message.FILE_NAME_REQUIRED}}</small>
            </div>
          </div>
          <video style="position: absolute; right: 0;visibility: hidden; z-index:-1" ref="tempVideo" controls src=""></video>
          <draggable
            v-model="fileInputs"
            v-bind="dragOptions"
            @start="drag = true"
            @end="drag = false"
            handle=".drag-handle"
            >
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <div class="avatar-addFile" v-for="(file,index) in fileInputs" :key="`key-${file.refIndex}`">
                <div class="input-upload drag-handle justify-content-between" v-if="file.popup">
                  <div class="d-flex align-items-center w-100">
                    <div class="avatar1 avatar-thumbnail upload-thumbnail">
                      <video width="100%" controls src="" :ref="`displayVideo-${file.refIndex}`" :id="`video-${file.refIndex}`" @canplaythrough="minuteVideo($event, index)" class="upload-video">
                      </video>
                      <div v-if="showProgressBar" class="progress-custom w-100">
                        <b-progress :value="progressValue" :max="max" animated></b-progress>
                      </div>
                    </div>
                    <div class="description" v-if="file.size > 0">
                      <div class="text-big d-none d-lg-block">{{file.videoName}} - {{convertSize(file.size)}}</div>
                      <div class="text-big d-lg-none d-block">{{file.videoName}} - {{convertSize(file.size)}}</div>
                    </div>
                  </div>
                  <div class="close-icon">
                    <img src="@img/icon/icon-close.svg" @click="changeVideo(index)">
                  </div>
                </div>
                <div class="input-upload drag-handle justify-content-between" v-else>
                  <div class="d-flex align-items-center input-group avatar-upload-mb">
                    <div class="avatar1 avatar-af">
                      <div class="input-upload">
                        <label :for="`uploadfile2-${index}`" class="label-upload"></label>
                        <input type="file" :id="`uploadfile2-${index}`" :name="`uploadfile2-${index}`" accept="video/*,video/mp4,video/m4v,video/mov,video/ogg" class="btn-file"  @change="changeFile($event, index)"/>
                      </div>
                    </div>
                    <div class="description">
                      <div class="text-big">ファイル選択</div>
                      <div class="text-small">最大{{settings.max_video_duration}}分のビデオ。</div>
                    </div>
                  </div>
                  <div class="close-icon">
                    <img src="@img/icon/icon-close.svg" @click="removeVideo(index)">
                  </div>
                </div>
                <div class="form-group drag-handle" >
                  <div class="input-group">
                    <small class="text-input error" v-if="hasError('format', file)">{{message.FILE_FORMAT}}</small>
                    <small class="text-input error" v-if="hasError('size', file)">動画は長さが{{settings.max_video_duration}}分まで</small>
                    <small class="text-input error" v-if="hasError('empty', file)">{{message.FILE_REQUIRED}}</small>
                    <small class="text-input error" v-if="errorMessage !== ''">{{errorMessage}}</small>
                  </div>
                </div>
                <div class="form-group mt-2 mb-4" v-if="file.popup">
                  <label class="vendor__label">トリムビデオ</label>
                  <vue-slider v-model="file.rangeValue" :tooltip="'always'" :min="0" :max="settings.video_seconds_duration" :dot-options="clip.dotOptions" :enable-cross="false" @drag-start="createThumbnailForSlider(file.file, index, $event)" @drag-end="createThumbnailForSlider(file.file, index, $event)">
                    <template v-slot:tooltip="{ value, focus }">
                      <canvas id="canvas"></canvas>
                      <div class="text-center">{{clip.tooltipFormat ? clip.tooltipFormat(): ''}}</div>
                    </template>
                  </vue-slider>
                </div>
              </div>
            </transition-group>
          </draggable>
          <b-button @click="addVideo" class="mt-3">
            動画を追加
          </b-button>
        </form>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <div class="d-flex justify-content-center btn-reverse">
            <b-button
              :disabled="buttonLoad"
              variant="secondary"
              class="btn btn-rounder btn-contact w-100 btn-basic mr-30"
              type="button" @click="closeModalAdd">キャンセル</b-button>
            <b-button
              variant="primary"
              :disabled="buttonLoad"
              class="btn-rounder btn-contact w-100 btn-basic"
              type="button" @click.prevent="mergeVideos">
                追加
                <span v-if="buttonLoad">
                  <b-spinner small></b-spinner>
                </span>
              </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {BModal, BProgressBar, VBModal} from 'bootstrap-vue'
import {mapState} from 'vuex'
import _ from 'lodash'
import {MESSAGE} from '@/utils/errorjapanese'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import draggable from 'vuedraggable'

export default {
  name: 'MergeFile',
  data () {
    return {
      checkChrome: false,
      checkFirefox: false,
      popup: false,
      fileName: '',
      fileError: false,
      errorMessage: '',
      message: MESSAGE,
      fileInputs: [],
      selectedVideos: [],
      max: 100,
      clip: {
        dotOptions: {
          tooltip: 'hover'
        }
      },
      drag: false,
      buttonLoad: false,
      settings: {
        video_seconds_duration: (5 * 60)
      }
    }
  },
  watch: {
    videos (newVal, oldVal) {
      if (!_.isEmpty(newVal)) {
        this.videoList = newVal
      }
    },
    'user' (newVal) {
      if (typeof newVal !== 'undefined') {
        this.settings = newVal.settings
      }
    }
  },
  components: {
    'b-modal': BModal,
    'b-progress-bar': BProgressBar,
    VueSlider,
    draggable
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  methods: {
    onOpen () {
      this.fileName = ''
      this.fileError = false
      this.errorMessage = ''
      this.fileInputs = [
        {
          file: null,
          videoName: '',
          duration: 0,
          size: 0,
          rangeValue: [0],
          min: 0,
          max: 100,
          errors: {},
          popup: false,
          refIndex: (Date.now() + Math.random())
        }
      ]
    },
    async changeFile (e, index) {
      e.preventDefault()
      const file = e.target.files[0]
      this.fileInputs[index].file = e.target.files[0]
      this.fileInputs[index].videoName = e.target.files[0].name
      this.fileInputs[index].size = e.target.files[0].size
      this.fileInputs[index].popup = true
      if (file.name.match(/\.(webm|mkv|flv|vob|avi|wmv|mp4|mov|m4v)$/i)) {
        let tempVideo = await new Promise((resolve, reject) => {
          setTimeout(() => {
            let videoRef = this.$refs.tempVideo
            videoRef.onloadedmetadata = function () {
              resolve(videoRef)
            }
            videoRef.src = URL.createObjectURL(e.target.files[0])
          }, 50)
        })

        if (parseInt(tempVideo.duration) > this.settings.video_seconds_duration) {
          this.fileInputs[index].popup = false
          this.fileInputs[index].errors.size = true
          this.$forceUpdate()
          return false
        }
        this.fileInputs[index].popup = true
        this.$refs[`displayVideo-${this.fileInputs[index].refIndex}`][0].src = URL.createObjectURL(e.target.files[0])
        tempVideo.ref = ''
        this.fileInputs[index].errors = {}
      } else {
        this.fileInputs[index].popup = false
        this.fileInputs[index].errors.format = true; return false
      }
    },
    minuteVideo (e, index) {
      this.fileInputs[index].rangeValue = [0, parseInt(e.target.duration)]
      this.fileInputs[index].max = parseInt(e.target.duration)
      // this.clip.tooltipFormat = value => this.secondsToHHMMSS(value).readableFormat
      this.fileInputs[index].duration = e.target.duration
      this.createThumbnailForSlider(this.fileInputs[index].file, index)
    },
    hasError (type, file) {
      if (Object.keys(file.errors).length > 0) {
        let keys = Object.keys(file.errors)
        if (type === 'empty') {
        }
        return keys.includes(type)
      }
      return false
    },
    removeVideo (index) {
      this.fileInputs.splice(index, 1)
    },
    changeVideo (index) {
      this.fileInputs[index].popup = false
    },
    addVideo () {
      this.fileInputs.push(
        {
          file: null,
          videoName: '',
          duration: 0,
          size: 0,
          rangeValue: [0],
          min: 0,
          max: 100,
          errors: {},
          popup: false,
          refIndex: (Date.now() + Math.random())
        }
      )
      if (this.fileInputs.length > 1) {
        this.errorMessage = ''
      }
    },
    async mergeVideos () {
      this.errorMessage = ''
      this.fileError = false
      if (this.fileInputs.length < 2) {
        this.errorMessage = '少なくとも2つのビデオを選択してください'
        this.$forceUpdate(); return
      }
      if (this.fileName === '') {
        this.fileError = true
        this.$forceUpdate(); return
      }

      // check for empty input fields
      let result = _.some(this.fileInputs, function (file) {
        return file.popup === false
      })

      if (result) {
        for (var x in this.fileInputs) {
          if (!this.fileInputs[x].popup) {
            this.fileInputs[x].errors.empty = true
          }
        }
        this.$forceUpdate(); return
      }

      this.buttonLoad = true

      let formData = new FormData()

      for (var i in this.fileInputs) {
        formData.append(`file${i}`, this.fileInputs[i].file)
        formData.append(`file${i}-duration`, this.fileInputs[i].duration)
        formData.append(`file${i}-min`, this.fileInputs[i].rangeValue[0])
        formData.append(`file${i}-max`, this.fileInputs[i].rangeValue[1])
      }
      formData.append('folder_parent_id', this.$route.params.id)
      formData.append('filename', this.fileName)
      formData.append('totalFiles', this.fileInputs.length)

      await this.$store.dispatch('managerFolder/mergeVideos', formData)
      this.buttonLoad = false
      this.reloadFile(1)
      setTimeout(() => {
        this.hideModal()
        this.clearData()
      }, 500)
    },
    clearData () {
      this.fileName = ''
      this.fileError = false
      this.errorMessage = ''
    },
    hideModal () {
      this.$bvModal.hide('modalVideoMerge')
    },
    closeModalAdd () {
      this.$bvModal.hide('modalVideoMerge')
    },
    remove (index) {
      this.tag.splice(index, 1)
    },
    createThumbnailForSlider (file, fileIndex, index = 0) {
      var canvas = document.getElementById('canvas')
      var video = document.createElement('video')
      // this is important
      video.autoplay = true
      video.muted = true
      video.src = URL.createObjectURL(file)

      video.currentTime = this.fileInputs[fileIndex].rangeValue[index]
      file.rangeValue = [...this.fileInputs[fileIndex].rangeValue]

      video.addEventListener('seeked', () => {
        canvas.width = 100
        canvas.height = 100
        this.clip.tooltipFormat = value => this.secondsToHHMMSS(this.fileInputs[fileIndex].rangeValue[index]).readableFormat
        let ctx = canvas.getContext('2d')
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

        canvas.toDataURL('image/jpeg')
      })
    }
  },
  computed: {
    ...mapState({
      videos: state => state.managerFolder.videos,
      progressValue: state => state.managerFolder.progressValue,
      showProgressBar: state => state.managerFolder.showProgressBar,
      user: state => state.allAuth.user
    }),
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  mounted () {
    var device = navigator.userAgent.toLowerCase()

    // add class for chrome in macos
    if (device.indexOf('chrome') > -1) {
      this.checkChrome = true
    }
    // add class for firefox in macos
    if (device.indexOf('firefox') > -1) {
      this.checkFirefox = true
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/vendor/detail_vendor.scss";
@import "@/assets/stylesheet/vendor/uploadfile.scss";
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>



// WEBPACK FOOTER //
// src/components/Manager/FolderManagerment/MergeVideo.vue